import React from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useHistory } from 'react-router-dom'

import SearchBar from 'components/SearchBar'
import { searchSalesEvents } from 'store/SalesEvents/actions'
import { getSearchSalesEventsValue } from 'store/SalesEvents/selectors'

const ListFilters = () => {
  const dispatch = useDispatch()
  const history = useHistory()

  const handleSearch = (value) => {
    dispatch(searchSalesEvents(value))
  }

  const searchSalesEventsValue = useSelector(
    getSearchSalesEventsValue
  )

  const redirectToAddNew = () => history.push('/sales-events/new')

  return (
    <div className="sales-events-filters">
      <SearchBar
        handleSearch={handleSearch}
        searchQuery={searchSalesEventsValue}
        // setPaginationToDefault={setPaginationToDefault}
      />
      <button
        className="btn new-item"
        type="button"
        onClick={redirectToAddNew}
      >
        <span className="new-item -cross"></span>
        <span className="new-item -cross"></span>
      </button>
    </div>
  )
}

export default ListFilters
